/**
 * ON AIR funnel event names.
 *
 * IMPORTANT: these names are the contract expected by the 4 GTM containers
 * (FR/ES/PT/MA), the ES tagging server and Looker. Do NOT rename them.
 * They intentionally differ from the resamania2-pass-app source module
 * (tunnel_start, offer_selected, ...): here we keep ON AIR's existing names.
 */
export const FUNNEL_EVENTS = {
  STEP_1: "funnel_step_1",
  STEP_2: "funnel_step_2",
  STEP_3: "funnel_step_3",
  STEP_4: "funnel_step_4",
  STEP_4_SEPA: "funnel_step_4_sepa",
  STEP_4_SIGN: "funnel_step_4_sign",
  STEP_5: "funnel_step_5",
  STEP_FINAL: "funnel_step_final",
  ADD_TO_CART: "add_to_cart",
  PURCHASE: "purchase",
};

/**
 * step_name values sent alongside funnel events (as historically emitted).
 */
export const STEP_NAMES = {
  CLUB: "Mon Club",
  SUBSCRIPTION: "Abonnement",
};

/**
 * funnel_club_status value (historically always "Ouvert").
 */
export const CLUB_STATUS_OPEN = "Ouvert";
